// -> IRoadmapManager (RoadmapController). UC-7/UC-8. Four routes for four costs - see
// RoadmapController.cs's own header for why GetFreshnessAsync is never folded into GetLiveAsync.
import { http } from "./http";
import type { DataFreshness, RoadmapFilterOptions, RoadmapView } from "./generated/contracts";

export interface RoadmapFilterParams {
  readonly teamGroups?: readonly string[];
  readonly statuses?: readonly string[];
  readonly teams?: readonly string[];
  readonly searchTerm?: string;
}

export const roadmapApi = {
  getLive: (filter: RoadmapFilterParams = {}) =>
    http.get<RoadmapView>("/api/roadmap", { query: { ...filter } }),

  getVersion: (versionKey: string, filter: RoadmapFilterParams = {}) =>
    http.get<RoadmapView>(`/api/roadmap/versions/${versionKey}`, { query: { ...filter } }),

  getFilterOptions: () => http.get<RoadmapFilterOptions>("/api/roadmap/filters"),

  getFreshness: () => http.get<DataFreshness>("/api/roadmap/freshness"),
};
